import React from 'react'

const JS_Essentials_Coding_Pratice_1 = () => {
  return (
    <div>
      <h1>Coding Practice 1</h1>
    </div>
  )
}

export default JS_Essentials_Coding_Pratice_1
